import React, { useState, useEffect, useRef } from "react";
import Loading from "../../components/customcomponents/loading";
import Layout from "../../components/include/layout";
import { useParams } from "react-router";
import { getBlog, getBlogCategoryComponent } from "../../data/api";
import { AiFillHeart, AiOutlineHeart } from "react-icons/ai";
import { FaRegCommentAlt } from "react-icons/fa";
import Error from "../../components/pages/404error";
import Widthcontainer from "../../components/customcomponents/widthcontainer";
import SideBar from "../components/SideBar.js";
import ReactLoading from "react-loading";
import { format } from "date-fns";
import MobileDropdown from "../components/MobileDropdown";
import RelatedSection from "../components/RelatedSection";
import CommentSection from "../components/CommentSection";
import { useMediaQuery } from "react-responsive";
import Token from "../../utils/useToken";
import LoginModal from "../../components/pages/loginmodal";
import { likeBlog, unlikeBlog } from "../../data/protectedapi";
import SeoTags from "../../utils/seoTags";
import HeroBanner from "../../components/customcomponents/herobanner.js";

export default function BlogPost() {
   const params = useParams();
   const { id } = params;
   const [loading, setLoading] = useState(true);
   const [blogLoading, setBlogLoading] = useState(false);
   const [error, setError] = useState(false);
   const [otherCategory, setOtherCategory] = useState([]);
   const [blog, setBlog] = useState([]);
   const [blogData, setBlogData] = useState({});
   const [featuredBlogs, setFeaturedBlogs] = useState([]);
   const [relatedBlogs, setRelatedBlogs] = useState([]);
   const [show, setShow] = useState(false);
   const [fetchData, setFetchData] = useState(false);
   const [isWaiting, setIsWaiting] = useState(false);
   const [commentLength, setCommentLength] = useState(0);

   const commentRef = useRef(null);

   const scrollDown = () => {
      window.scrollTo(0, commentRef.current.offsetTop - 150);
   };

   useEffect(() => {
      async function getData() {
         otherCategory?.length == 0 && setLoading(true);
         const response = await getBlog(id);
         if (response.status !== 200) setError(true);
         otherCategory?.length > 0 && setBlogLoading(true);
         console.log(response);
         setOtherCategory(response?.data?.Category);
         setBlogData(response?.data?.data);
         setBlog(response?.data?.html);
         setFeaturedBlogs(response?.data?.featuredBlogs);
         setRelatedBlogs(response?.data?.relatedBlogs);
         setLoading(false);
         setBlogLoading(false);
         setIsWaiting(false);
      }
      getData();
   }, [id, fetchData]);
   const isMobile = useMediaQuery({ query: "(max-width: 900px)" });
   const bannerData = {
      media_type: "image", // or "image"
      media: blogData?.banner_image,
      mobile_media_type: "image", // or "image"
      mobile_media: blogData?.banner_image, // replace with the actual mobile video file
      mobile_mute: true, // true or false
      mute: false, // true or false
      text_align: "", // "left", "center", or "right"
      text_color: "#ffffff", // replace with the desired text color
      caption: "",
      sub_caption: "",
      button_type: "", // replace with the desired button text
      button_bg_color: "#ED1C24", // replace with the desired button background color
      button_text_color: "#ffffff", // replace with the desired button text color
      external_link: "", // replace with the actual external link
   };
   return error ? (
      <Error />
   ) : (
      <Layout footer={"blog"}>
         {loading ? (
            <Loading />
         ) : (
            <>
               {blogData?.banner_image ? <HeroBanner data={bannerData} /> : null}
               {SeoTags(blogData?.title)}
               <Widthcontainer className={"blogCategory__content__container"}>
                  <div className="fixed-width blogCategory__content__wrapper">
                     <LoginModal Show={show} setShow={setShow} link={`/company/blogs/${id}`} />
                     <MobileDropdown categories={otherCategory} navigate={true} />
                     {blogLoading ? (
                        <div
                           className="d-flex align-items-center justify-content-center"
                           style={{ flex: "1" }}
                        >
                           <ReactLoading type="cylon" color="#ed1c24" height={305} width={305} />
                        </div>
                     ) : (
                        <div className="blogCategory__content__wrapper__blog__post">
                           <h3 className="blogPost__title">{blogData?.title}</h3>
                           <p className="blogPost__date">
                              {blogData?.created_at &&
                                 format(
                                    new Date(blogData?.created_at),
                                    "MMM dd, yyyy 'at' hh:mm b",
                                 )}
                           </p>
                           <BlogPostLike
                              id={id}
                              data={blogData?.likes}
                              setLoginShow={setShow}
                              fetchData={fetchData}
                              setFetchData={setFetchData}
                              isWaiting={isWaiting}
                              setIsWaiting={setIsWaiting}
                              commentLength={commentLength}
                              scrollDown={scrollDown}
                           />
                           <div
                              dangerouslySetInnerHTML={{ __html: blog }}
                              className="blogPost__html__container"
                           />
                           <div className="blogPost__footer">
                              <p className="categories__text ">
                                 Categories:{" "}
                                 {Object.entries(blogData?.category_id)?.map(([key, value]) => {
                                    return key > 0
                                       ? `, ${value?.id?.title}`
                                       : `${value?.id?.title}`;
                                 })}
                              </p>
                           </div>
                           {isMobile && (
                              <CommentSection
                                 id={id}
                                 setCommentLength={setCommentLength}
                                 scrollRef={commentRef}
                              />
                           )}
                        </div>
                     )}
                     <SideBar
                        featuredBlogs={featuredBlogs}
                        otherCategory={otherCategory}
                        navigate={true}
                     />
                  </div>
                  {!isMobile && (
                     <CommentSection
                        id={id}
                        setCommentLength={setCommentLength}
                        scrollRef={commentRef}
                     />
                  )}
                  <RelatedSection data={relatedBlogs} />
               </Widthcontainer>
            </>
         )}
      </Layout>
   );
}

function BlogPostLike({
   id,
   data,
   setLoginShow,
   isWaiting,
   setIsWaiting,
   fetchData,
   setFetchData,
   commentLength,
   scrollDown,
}) {
   console.log("like", data);
   const { userDetails } = Token();
   const [isLiked, setIsLiked] = useState(false);
   useEffect(() => {
      let alreadyLiked = false;
      if (data) {
         for (const [key, value] of Object.entries(data)) {
            if (value?.user_id === userDetails?.id) {
               alreadyLiked = true;
               break; // Exit the loop once a match is found
            }
         }
      }
      if (alreadyLiked) setIsLiked(true);
      else setIsLiked(false);
      // If no match is found, isLiked will remain false
   }, [data]);

   const handleLike = async () => {
      const res = await likeBlog(id);
      if (res?.status === 201) {
         setFetchData(!fetchData);
      }
   };
   const handleUnLike = async () => {
      const res = await unlikeBlog(id);
      if (res?.status === 200) {
         setFetchData(!fetchData);
      }
   };
   const handleLikeUn = async () => {
      if (!userDetails) setLoginShow(true);
      if (isWaiting) return;
      setIsWaiting(true);
      if (isLiked) handleUnLike();
      else handleLike();
   };
   return (
      <div className="blogPostLike__container">
         <div className="icon__container">
            {isLiked ? (
               <AiFillHeart
                  className="icon red"
                  style={isWaiting ? { cursor: "progress" } : {}}
                  onClick={() => {
                     handleLikeUn();
                  }}
               />
            ) : (
               <AiOutlineHeart
                  className="icon"
                  style={isWaiting ? { cursor: "progress" } : {}}
                  onClick={() => {
                     handleLikeUn();
                  }}
               />
            )}
            <p className="text">{data?.length ? data?.length : 0}</p>
         </div>
         <div className="icon__container">
            <FaRegCommentAlt
               className="icon"
               style={{ height: "18px", width: "20px" }}
               onClick={() => scrollDown()}
            />
            <p className="text">{commentLength}</p>
         </div>
      </div>
   );
}
